import React from "react";
import ReactDOM from "react-dom/client";
import "./index.min.css";
import { ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import reportWebVitals from "./reportWebVitals";
import AppRoutes from "./routes";
import { muiCustomTheme } from "./libs/mui";
import { AppProvider } from "./context";

// CONFIGS
const queryClient = new QueryClient();
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// RENDER
const render = () => (
  <QueryClientProvider client={queryClient}>
    <AppProvider>
      <ThemeProvider theme={muiCustomTheme}>
        <AppRoutes />
      </ThemeProvider>
    </AppProvider>
  </QueryClientProvider>
);

if (process.env.NODE_ENV === "development") {
  root.render(render());
} else {
  root.render(<React.StrictMode>{render()}</React.StrictMode>);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
